import { ChakraProvider, extendTheme } from '@chakra-ui/react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'

import store from '@core/app/store/store'

import { ThemeProvider } from '@core/utils/contexts/ThemeContext/ThemeContext'
import ErrorBoundary from '@core/utils/helpers/errorBoundary'

import '@core/utils/i18n'

import { initSentry } from '@core/utils/sentry/initSentry'
import NewsPage from './NewsPage'
import theme from './theme.js'
import './index.css'

initSentry()

const app = document.getElementById('root')
const root = createRoot(app!)

const router = createBrowserRouter([
    {
        path: process.env.ENV === 'local' ? '' : 'newsfeed',
        element: (
            <ErrorBoundary fallback={<div>Something went wrong...</div>}>
                <ThemeProvider>
                    <NewsPage />
                </ThemeProvider>
            </ErrorBoundary>
        ),
    },
])
root.render(
    <>
        <Provider store={store}>
            <ChakraProvider theme={theme}>
                <RouterProvider router={router} />
            </ChakraProvider>
        </Provider>
    </>
)
